import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useGetApiClient } from "api/get-api-client";

const useApiTeamRiskyFeedbackComplete = () => {
  const apiClient = useGetApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      await apiClient.team.riskyFeedbackComplete();
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["auth-new"] });
    },
  });
};

export default useApiTeamRiskyFeedbackComplete;
